import React, {ComponentPropsWithoutRef, FC} from 'react';

import {twx} from '@/utils/tailwindUtils';

export const Title: FC<ComponentPropsWithoutRef<'h1'>> = ({className, children, ...props}) => {
    return (
        <h1 className={twx('m-0 text-28 font-bold leading-143 text-romance', className)} {...props}>
            {children}
        </h1>
    );
};

export const Description: FC<ComponentPropsWithoutRef<'span'>> = ({className, children, ...props}) => {
    return (
        <span className={twx('max-w-[260px] font-normal leading-143 text-romance', className)} {...props}>
            {children}
        </span>
    );
};
